import { Button } from 'antd';
import { setNestedObjectValues, useFormikContext } from 'formik';
import { useCallback, useContext, useMemo } from 'react';

import './VendorLeadStepLayoutNextButton.scss';

import { isVendorStepSubmitted } from 'src/helpers/isVendorStepSubmitted';
import { VendorsContext } from 'src/pages/VendorsPage/VendorsPage.context';

export function VendorLeadStepLayoutNextButton() {
  const { vendorStepsInfo, vendorLeadProduct, vendorLeadProductSpecification, goNextStep, isLastVendorStep } =
    useContext(VendorsContext);

  const { isSubmitting, validateForm, submitForm, setTouched } = useFormikContext<unknown>();

  const isCompleted = useMemo(
    () =>
      vendorStepsInfo.every((vendorStepInfo) =>
        isVendorStepSubmitted(vendorStepInfo.step, vendorLeadProduct, vendorLeadProductSpecification)
      ),
    [vendorStepsInfo, vendorLeadProduct, vendorLeadProductSpecification]
  );

  const handleClick = useCallback(async () => {
    const errors = await validateForm();

    if (Object.keys(errors).length === 0) {
      // Use `status`?
      const isGoToNextStep = (await submitForm()) as unknown as boolean;

      if (isGoToNextStep) {
        goNextStep();
      }
    } else {
      await setTouched(setNestedObjectValues(errors, true));
    }
  }, [validateForm, submitForm, goNextStep, setTouched]);

  return (
    <Button
      className="vendor-lead-step-layout__next-button"
      type="primary"
      disabled={isSubmitting}
      loading={isSubmitting}
      onClick={handleClick}
    >
      {isLastVendorStep ? (isCompleted ? 'Submit' : 'Save for Later') : 'Next Section'}
    </Button>
  );
}
